import { Flex, Text, Td, Tr, Button } from '@chakra-ui/react';
import { CustomSendIcon } from '../../../theme/icons/CustomSendIcon';
import { ROLES } from '../../../constants/roles';
import { useContext } from 'react';
import { MeContext } from '../../../context/MeContext';
import { useMediaQuery } from '@chakra-ui/react';
import InvitationMoreInfo from './InvitationMoreInfo';
import TeamInvitationsOptions from './TeamInvitationsOptions';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';

const TeamInvitationRow = ({
  invitation,
  handleResendInvitation,
  getEntityName,
}) => {
  const isReadOnly = useIsReadOnly();
  const [isLargerThan2XL] = useMediaQuery('(min-width: 96em)');
  const [isLargerThanXS] = useMediaQuery('(min-width: 30em)');
  const meContext = useContext(MeContext);
  const isOrgAdmin = meContext.isOrgAdmin();
  const isAdmin = meContext.isAdmin();

  return (
    <Tr>
      <Td>
        <Flex align="center" gap={2}>
          {!invitation.emailVerified && <Text>⏳</Text>}
          <Flex align="start" direction="column">
            {invitation.emailVerified && (
              <Text fontWeight="bold">
                {invitation?.firstName} {invitation?.lastName}
              </Text>
            )}
            <Text fontSize={invitation.emailVerified ? '12px' : ''}>
              {invitation.email}
            </Text>
          </Flex>
        </Flex>
      </Td>
      <Td display={isLargerThan2XL ? 'table-cell' : 'none'}>
        <Flex align="start" direction="column">
          <Text fontWeight="bold">{ROLES[invitation.role].label}</Text>
          <Text fontSize="12px">
            {invitation.role !== ROLES.org_admin.value &&
              invitation.entityId &&
              ` (${getEntityName(invitation.entityId)})`}
          </Text>
        </Flex>
      </Td>
      {isOrgAdmin && (
        <Td display={isLargerThan2XL ? 'table-cell' : 'none'}>
          {!invitation.emailVerified && (
            <Button
              variant="link"
              pt="1px"
              size="sm"
              isDisabled={isReadOnly}
              onClick={() =>
                handleResendInvitation(
                  invitation.email,
                  invitation.role,
                  invitation.entityId,
                  invitation.companyName
                )
              }
            >
              <Flex justifyContent="center" align="center">
                <CustomSendIcon />
                <Text textStyle="bodyFamilyMedium" pl="7px">
                  Resend
                </Text>
              </Flex>
            </Button>
          )}
        </Td>
      )}
      {isAdmin && (
        <Td display={isLargerThan2XL ? 'table-cell' : 'none'}>
          <TeamInvitationsOptions invitation={invitation} />
        </Td>
      )}
      <Td display={!isLargerThan2XL ? 'table-cell' : 'none'}>
        <InvitationMoreInfo
          invitation={invitation}
          handleResendInvitation={handleResendInvitation}
          getEntityName={getEntityName}
        />
      </Td>
    </Tr>
  );
};

export default TeamInvitationRow;
